export enum PredefinedCustomFilterId {
  CUSTOM_PACING_ELIGIBLE = 'customPacingEligibilityPreset',
}
